import React from "react";
import "./css/contacts.css";
import ButtonLine from "../../components/buttonLine/buttonLine";
import logoFacebook from "../../resources/img/servicesimg/Facebook.svg";
import logoInstagram from "../../resources/img/servicesimg/Instagram.svg";
import logolinkendin from "../../resources/img/servicesimg/Linkedin.svg";
import { motion } from "motion/react";
import { Link } from "react-router-dom";

const Contacts = () => {
  const avoidWidows = (text) => {
    return text.replace(/\s(?=\S+$)/, "\u00A0");
  };

  return (
    <motion.div
      key={"empty"}
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="d-flex flex-column min-vh-100">
        {/* Título */}
        <div className="col-12 d-flex justify-content-center mb-5">
          <div className="color-text-gris-hv">Contact</div>
        </div>
        {/* Texto descriptivo */}
        <div className="col-12 d-flex justify-content-center mb-5">
          <div
            className="color-text-barlow-regular-20-hv text-center d-flex justify-content-center"
            style={{ maxWidth: "650px", lineHeight: "1.5" }}
          >
            {avoidWidows(
              "If you would like to discuss your ideas, ask questions or receive additional information, you are welcome to get in touch. I look forward to hearing about your project and exploring how we can work together."
            )}
          </div>
        </div>
        {/* Botón */}
        <div className="col-12 d-flex justify-content-center mb-5 mt-5">
          <a
            href="mailto:hello@hvhelmut.com"
            className="btn btn-custom w-30 mt-2 mt-md-1"
          >
            Let’s talk!
          </a>
        </div>

        <div className="col-12 d-flex justify-content-center mt-3 mb-5">
          <div
            className="color-text-barlow-regular-20-hv text-center d-flex justify-content-center"
            style={{ maxWidth: "650px", lineHeight: "1.5" }}
          >
            {avoidWidows("Or: hello@hvhelmut.com")}
          </div>
        </div>

        {/* Redes sociales */}
        <div className="col-12 d-flex flex-wrap justify-content-center align-items-center gap-3 py-2 mt-3 mb-5">
          <a href="https://www.facebook.com/hvhelmut1" target="_blank">
            <img
              src={logoFacebook}
              alt="facebook"
              width="17"
              height="17"
              className="d-inline-block"
            />
          </a>

          <a href="https://www.instagram.com/hv.helmut/" target="_blank">
            <img
              src={logoInstagram}
              alt="instagram"
              width="17"
              height="17"
              className="d-inline-block"
            />
          </a>

          <a
            href="https://co.linkedin.com/in/helmut-hern%C3%A1ndez-v-2a3b07116/en"
            target="_blank"
          >
            <img
              src={logolinkendin}
              alt="linkedin"
              width="17"
              height="17"
              className="d-inline-block"
            />
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default Contacts;
